<template>
  <div class="radar-grid">
    <RadarCard v-for="(item, index) in workbench.sortedKeywordData" :key="item.keyword" :item="item" :index="index" />
  </div>
</template>

<script setup>
import RadarCard from './RadarCard.vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

const workbench = useWorkbenchStore()
</script>
